import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_FALLBACK_JSON_ID, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import DealerAdIframe from '../../dealer';
const DesktopDevPageStage728x90 = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const dealerJson = useFlag('dealer_json_offer');
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['UserDesktopDevPageStage728x90Gam'], safety, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            [
                728,
                90
            ],
            [
                320,
                50
            ],
            [
                300,
                50
            ]
        ],
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    if (advertIsOff === 'fallback') {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '728px',
                height: '90px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: dealerJson ? ADUNIT_FALLBACK_JSON_ID : ADUNIT_FALLBACK_MAP['UserDesktopDevPageStage728x90Gam'],
            offerName: "DesktopDevPageStage728x90Gam",
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopDevPageStage728x90.displayName = 'DesktopDevPageStage728x90';
export default DesktopDevPageStage728x90;
